"use strict";

exports.__esModule = true;
exports.default = clearUndefinedProperties;
function clearUndefinedProperties(obj) {
  if (!obj) {
    return obj;
  }

  var newObj = {};

  Object.keys(obj).forEach(function (propertyName) {
    var value = obj[propertyName];
    if (value !== undefined) {
      newObj[propertyName] = value;
    }
  });

  return newObj;
}
//# sourceMappingURL=clearUndefinedProperties.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/utils/clearUndefinedProperties.js
// module id = 135
// module chunks = 95715928098905 172441821870073 232727283551173